import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

function getItems() {
  return apiClient.get(`${ApiConfig.ItemConfig.ITEMS}`).then(response => response?.data)
}

export default getItems
